import request from './services/axios.js'

export default {
  // 添加子账号
  addSubAccount: (params) => {
    return request({
      params,
      url: 'ebook/childA/addChildAccount.do',
      method: 'POST'
    })
  },
  // 获取子账号列表
  getSubAccountList: (params) => {
    return request({
      params,
      url: 'ebook/childA/getChildAccountByPage.do',
      method: 'get'
    })
  },
  // 发布及权限功能 - 账号所属的主账号、子账号列表
  getMainChildAccountList: (params) => {
    return request({
      params,
      url: 'ebook/childA/getMainChildAccountList',
      method: 'get'
    })
  },
  removeSubAccount: (params) => {
    return request({
      params,
      url: 'ebook/childA/delChildAccount.do',
      method: 'get'
    })
  },
  modifyPassword: (params) => {
    return request({
      params,
      url: '/ebook/childA/modifyChildPassword.do',
      method: 'POST'
    })
  },
  setManagePaper: (params) => {
    return request({
      params,
      url: 'ebook/childA/setManagePaper',
      method: 'POST'
    })
  },
  getChildAccount: (params) => {
    return request({
      params,
      url: 'ebook/childA/getChildAccount',
      method: 'get'
    })
  }
}
